import SelectContacts from './SelectContacts.component';

export default SelectContacts;